import { render, staticRenderFns } from "./NicheIcon.vue?vue&type=template&id=bfd04178&scoped=true"
import script from "./NicheIcon.vue?vue&type=script&lang=js"
export * from "./NicheIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfd04178",
  null
  
)

export default component.exports